import { noop } from '@proc7ts/primitives';
/**
 * Creates a route capture receiver that classifies the capture by its kind.
 *
 * @param classifier - Route capture classifier.
 * @param fallback - Fallback route capture that will be called when no matching method defined in classifier.
 *
 * @returns New route capture receiver function that calls classifier's method corresponding to the kind of the capture,
 * or `fallback` function if no such method defined in classifier.
 */
export function classifyRouteCapture(classifier, fallback = noop) {
    return (kind, key, ...capture) => {
        const kindCaptor = classifier[kind];
        if (kindCaptor) {
            kindCaptor(key, ...capture);
        }
        else {
            fallback(kind, key, ...capture);
        }
    };
}
//# sourceMappingURL=classify-route-capture.js.map